import { Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import CustomerRedirectLink from './CustomerRedirectLink';
import AutoPayPage from './pages/AutoPayPage';
import NachPaymentSummary from './pages/PaymentSummary';
import { NotFound } from 'common/components';
import { customer_routes } from './routes';
import RazorpayNachPaymentSummary from './pages/PaymentSummaryRazorpay';
import SuccessPage from './pages/SuccessPage';
// import WaitingPage from './pages/WaitingPage';

const NachCustomerRedirectContainer = () => (
  <Routes>
    <Route element={<Header />}>
      <Route
        path={customer_routes.customer_redirect_link.path}
        element={<CustomerRedirectLink />}
      />
      <Route path={customer_routes.AutoPay.path} element={<AutoPayPage />} />
      <Route
        path={customer_routes.customer_payment_summary.path}
        element={<NachPaymentSummary />}
      />
      <Route
        path={customer_routes.nach_payment_summary.path}
        element={<RazorpayNachPaymentSummary />}
      />
      {/* <Route path={customer_routes.waiting_page.path} element={<WaitingPage />} /> */}
      <Route path={customer_routes.success_page.path} element={<SuccessPage />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
);

export default NachCustomerRedirectContainer;
